import { ComponentProps, FC } from 'react';
import dayjs from 'dayjs';
import { DatePicker as AntdDatePicker } from 'antd';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CalendarTodayOutlined } from '@mui/icons-material';
import { Stack, useTheme } from '@mui/material';
import { getNightOrDayPalette } from '../utils/getNightOrDayPalette';

type Props = Omit<ComponentProps<typeof AntdDatePicker>, 'value' | 'onChange'> &
	Readonly<{
		value: string | null;
		onChange: (value: string | null) => void;
	}>;

const DatePicker: FC<Props> = ({ value, onChange, ...props }) => {
	const theme = useTheme();

	return (
		<Stack
			direction={'row'}
			flexWrap={'nowrap'}
			width={'100%'}
			alignItems={'center'}
			sx={{
				border: (theme) => `1px solid ${theme.palette[getNightOrDayPalette(theme)][300]}`,
				px: 1.5,
				borderRadius: 1,
				paddingRight: 0,
				'& .ant-picker-input > input': {
					color: `${theme.palette.text.primary} !important`,
				},
				'.ant-picker-panel-container': {
					background: theme.palette[getNightOrDayPalette(theme)][0],
				},
			}}
		>
			<CalendarTodayOutlined color={'secondary'} />
			<AntdDatePicker
				picker={'date'}
				size={'large'}
				bordered={false}
				style={{ width: '100%' }}
				suffixIcon={<ArrowDropDownIcon sx={{ position: 'relative', right: '-5px', color: (theme) => theme.palette.grey[800] }} />}
				popupStyle={{
					zIndex: theme.zIndex.datePicker,
				}}
				value={value == null ? null : dayjs(value)}
				onChange={
					(date) =>
						onChange(
							date == null ? null : `${dayjs(date as string).format('YYYY-MM-DD')}T00:00:00Z`,
						) /* date picker should not have time portion set */
				}
				{...props}
			/>
		</Stack>
	);
};

export { DatePicker };
